import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { withStyles } from '@material-ui/core/styles';
import MuiBadge from '@material-ui/core/Badge';

const styles = (theme) => ({
  badge: (props) => {
    let custom = {};
    if (props.bgcolor) {
      custom = { ...custom, backgroundColor: props.bgcolor };
    }
    if (props.type === 'small') {
      custom = {
        ...custom,
        fontSize: 10,
        height: 16,
        right: -2,
      };
    } else if (props.type === 'addInfo') {
      custom = {
        ...custom,
        right: -8,
        top: 14,
        width: 24,
        height: 24,
        border: `2px solid ${theme.palette.background.paper}`,
      };
    }
    if (props.gap === 'large') {
      custom = { ...custom, right: -10 };
    }
    return custom;
  },
});

const StyledBadge = withStyles(styles)(MuiBadge);

const Badge = ({
  content, backgroundColor, type, gap, max, showZero, children,
}) => {
  // Component props
  const badgeProps = {
    badgeContent: content,
    color: 'primary',
    bgcolor: backgroundColor,
    type,
    gap,
    max,
    showZero,
  };

  return (
    <StyledBadge {...badgeProps}>
      { children }
    </StyledBadge>
  );
};

Badge.propTypes = {
  content: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
  type: PropTypes.string,
  gap: PropTypes.string,
  max: PropTypes.number,
  showZero: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Badge.defaultProps = {
  backgroundColor: null,
  type: 'default',
  gap: 'default',
  max: 99,
  showZero: true,
};

export default React.memo(Badge);



// WEBPACK FOOTER //
// ./components/core/Badge.js